var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-video-player"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.video,"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }